import { Rule } from "antd/lib/form";

export const Rules = {
  required(message?: string): Rule {
    return { required: true, message: message || "Vui lòng nhập trường này" };
  },
  required2Field(alternateField: string, message?: string): Rule {
    return ({ getFieldValue }) => ({
      validator(_, value) {
        if (value || getFieldValue(alternateField)) {
          return Promise.resolve();
        }
        return Promise.reject(
          new Error(message || "Vui lòng chọn trường này!")
        );
      },
    });
  },
};
